
<div class="amplify-interactions">
	<div class="amplify-interactions-container">
		<div class="amplify-form-container">
			<div class="amplify-form-row">
				<div class="amplify-interactions-conversation">
					<div *ngFor="let message of messages">
						<div class="amplify-interactions-input">{{message.me}}</div>
						<div class="amplify-interactions-input-timestamp">{{message.meSentTime}}</div>
						<div class="amplify-interactions-response">{{message.bot}}</div>
						<div class="amplify-interactions-response-timestamp">{{message.botSentTime}}</div>
					</div>
				</div>
			</div>
			<div class="amplify-interactions-actions">
				<input #inputValue
					type='text'
					class="amplify-form-input"
					placeholder="{{currentVoiceState}}"
					[value]="inputText"
					(keyup.enter)="onSubmit(inputValue.value)"
					(change)="onInputChange($event.target.value)"
					[disabled]="inputDisabled"
					*ngIf="textEnabled">
				<input #inputValue
					type='text'
					class="amplify-form-input"
					placeholder="{{currentVoiceState}}"
					[disabled]="!textEnabled"
					*ngIf="!textEnabled">

				<button
					type="button"
					*ngIf="voiceEnabled"
					ng-style="{float: 'right'}"
					(click)="micButtonHandler()"
					[disabled]="micButtonDisabled"
				>
					{{micText}}
				</button>
				<button
					type="button"
					*ngIf="textEnabled"
					ng-style="{float: 'right'}"
					class="amplify-interactions-button"
					[disabled]="inputDisabled"
					ng-click="!inputDisabled || onSubmit(inputValue.value)"
				></button>
			</div>
		</div>
	</div>
</div>
